export default "__VITE_ASSET__Fzq1bW7Y__"